import getLocaleWeekFirstDayNumber from "./getLocaleWeekFirstDayNumber";
import isWeekday from "./isWeekday";

export default function(locale = "en-US", size) {
    //Note: building around a known Sunday - 06/20/1971 (two years after Moon landing)
    let workDate;
    let result = [];
    let localeIndex = getLocaleWeekFirstDayNumber(locale);
    for (let i = 0; i < 7; i++) {
        localeIndex = localeIndex % 7;
        workDate = new Date("06/2" + localeIndex++ + "/1971");
        result.push({
            name: workDate.toLocaleDateString(locale, { weekday: size }),
            isWeekday: isWeekday(workDate)
        });
    }

    return result;
}
